export default class LiveChat {
    static init() {
        if (!window.sprChatSettings?.appId) {
            return;
        }
        if (document.getElementById('spr-chat-bootstrap')) {
            return;
        }
        const script = document.createElement('script');
        script.id = 'spr-chat-bootstrap';
        script.type = 'text/javascript';
        script.text = `(function(){
                var t=window,e=t.sprChat,a=e&&!!e.loaded,n=document,r=function() {r.m(arguments)};
                r.q=[],r.m=function(t){r.q.push(t)},t.sprChat=a?e:r;
                var o=function(){
                    var e=n.createElement("script");e.type="text/javascript",e.async=!0,e.src="https://prod-live-chat.sprinklr.com/api/livechat/handshake/widget/" + t.sprChatSettings.appId
                        ,e.onerror=function() {t.sprChat.loaded=!1}
                        ,e.onload=function() {t.sprChat.loaded=!0};
                    var a=n.getElementsByTagName("script")[0];
                    a.parentNode.insertBefore(e,a)
                };
                "function"==typeof e?a?e("update",t.sprChatSettings):o():"loading"!==n.readyState?o():n.addEventListener("DOMContentLoaded",o)
            })()`;
        document.head.appendChild(script);
    }
}
